// 金额格式化
export function sumFormater(num) {
    if (!num) return '0.00'
    // 将数据分割，保留两位小数
    num = Number(num).toFixed(2)
    // 获取整数部分
    const intPart = Math.trunc(num)
    // 整数部分处理，增加,
    const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
    // 预定义小数部分
    let floatPart = '.00'
    // 将数据分割为小数部分和整数部分
    const newArr = num.toString().split('.')
    if (newArr.length === 2) { // 有小数部分
        floatPart = newArr[1].toString() // 取得小数部分
        return intPartFormat + '.' + floatPart
    }
    return intPartFormat + floatPart
}
// 吨数格式化
export function tonnageFormater(num) {
    if (!num) return '0.00'
    return (Math.round(num * 100) / 100).toFixed(2)
}